import { useState } from "react";
import { Gift, ScanLine, Check } from "lucide-react";

const GOAL = 6;
const CELLS = Array.from({ length: 121 }, (_, i) => ((i * 37 + (i % 7) * 13) % 5) < 2);
const corner = (r, c) => (r < 3 && c < 3) || (r < 3 && c > 7) || (r > 7 && c < 3);

export const QrDemo = () => {
  const [visits, setVisits] = useState(2);
  const [scanning, setScanning] = useState(false);
  const full = visits >= GOAL;

  const scan = () => {
    if (full) return setVisits(0);
    setScanning(true);
    setTimeout(() => { setScanning(false); setVisits((v) => v + 1); }, 700);
  };

  return (
    <div className="grid sm:grid-cols-2 gap-4 items-center" data-testid="qr-demo">
      <div className="relative mx-auto bg-white p-3 rounded-xl w-40 h-40 overflow-hidden">
        <div className="grid grid-cols-11 gap-[1px] w-full h-full">
          {CELLS.map((on, i) => {
            const r = Math.floor(i / 11), c = i % 11;
            return <span key={i} className={corner(r, c) || on ? "bg-[#1a1917]" : "bg-white"} />;
          })}
        </div>
        {scanning && <div className="absolute inset-x-0 h-1 bg-[#D6AD62] shadow-[0_0_14px_#D6AD62] adv-scan" />}
      </div>
      <div>
        <div className="text-sm text-[#a9a398]">Bonus kartı</div>
        <div className="font-display text-2xl font-bold" data-testid="qr-visits">{visits} / {GOAL} səfər</div>
        <div className="flex gap-1.5 mt-3">
          {Array.from({ length: GOAL }).map((_, i) => (
            <span key={i} className={`h-8 w-8 rounded-full grid place-items-center ${i < visits ? "bg-[#D6AD62] text-[#111110]" : "bg-white/5 border border-white/10"}`}>
              {i < visits && <Check className="h-4 w-4" />}
            </span>
          ))}
        </div>
        {full && (
          <div className="mt-3 flex items-center gap-2 text-emerald-300 text-sm font-semibold" data-testid="qr-reward">
            <Gift className="h-4 w-4" /> Təbriklər! Növbəti xidmət hədiyyədir
          </div>
        )}
        <button className="adv-btn w-full mt-4 text-sm" onClick={scan} disabled={scanning} data-testid="qr-scan-btn">
          <ScanLine className="h-4 w-4" /> {full ? "Hədiyyəni istifadə et" : "QR kodu skan et"}
        </button>
      </div>
    </div>
  );
};
